import { Flex, Text } from "@chakra-ui/react";

export function Footer() {
  return <Flex backgroundColor="white" align="center" justify="center" py={2}>
    <Text> 2026 © Actionlabs, All Right Reserved</Text>
  </Flex>;
}

export default Footer;
